<script setup>
import { STEPS } from '../../constants/steps';
import { useSubmitStore } from '../../stores/submit.js';
import { useUiStore } from '../../stores/ui.js';
import Icon from '../Icon.vue';
import Save from './Save.vue';

const submitStore = useSubmitStore();
const uiStore = useUiStore();
</script>

<template>
    <div v-if="uiStore.currentStepIndex > 0 && !submitStore.isFinished" class="tw-z-50">
        <div class="tw-flex tw-justify-between tw-items-center tw-px-3 md:tw-px-5 xxl:tw-px-8 xxxl:tw-px-10 tw-py-4 xxl:tw-py-6 tw-bg-white tw-shadow-configurator">
            <Save />

            <button
                type="button"
                class="btn link"
                @click="uiStore.showSaveConfig = true"
            >
                <Icon name="save" class="tw-size-6" />
            </button>
            

            <div class="tw-flex tw-flex-row tw-space-x-3 xl:tw-space-x-5">
                <button
                    type="button"
                    class="btn btn-configurator outline gray"
                    @click="uiStore.goToPreviousStep()"
                    v-t="`website.configurator.prev`"
                >
                </button>

                <button
                    type="button"
                    class="btn btn-configurator primary"
                    v-if="uiStore.currentStepIndex < STEPS.length - 1"
                    @click="uiStore.goToNextStep();"
                    v-t="`website.configurator.next`"
                >
                </button>

                <button
                    type="submit"
                    class="btn btn-configurator primary"
                    v-if="uiStore.currentStepIndex === STEPS.length - 1"
                    @click="submitStore.submit()"
                    :disabled="!submitStore.canSubmit"
                    v-t="`website.configurator.send`"
                >
                </button>
            </div>
        </div>

        <div class="lg:tw-hidden tw-absolute tw-right-3 tw-top-0 tw-translate-y-[-150%]">
            <span
                class="btn btn-configurator brand rounded white tw-bg-white tw-shadow-configurator tw-text-brand-500 tw-border tw-border-white tw-flex tw-items-center tw-justify-start"
                v-if="uiStore.details"
                @click="uiStore.showDetails = !uiStore.showDetails, uiStore.showRoomConfig = false"
                :class="{'tw-border-gray-100 tw-border tw-text-gray-700 !tw-px-2 !tw-py-2 lg:!tw-px-2 xl:!tw-px-3': uiStore.showDetails}"
            >
                <Icon v-if="!uiStore.showDetails" name="info" class="tw-size-4 md:tw-size-5 lg:tw-size-6" />
                <Icon v-if="uiStore.showDetails" name="close" class="tw-size-4 md:tw-size-5 lg:tw-size-6" />
                <span v-if="!uiStore.showDetails" class="tw-ml-2" v-t="`website.configurator.details`"></span>
            </span>
        </div>
    </div>
</template>
